import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import arrowLeftIcon from "@iconify/icons-mdi/arrow-left";
import { InlineIcon } from "@iconify/react";
import { useMyCafeteriaCurrentStatement } from "my-cafeteria/hooks";
import { OcCustomTooltip } from "oc/components";
import { useOcCurrentUserState } from "oc/hooks";

interface OcPrintHeaderProps {
  title: string;
  onBack: () => void;
  onPrint: () => void;
  isMobile: boolean;
}

export const OcPrintHeader: React.FC<OcPrintHeaderProps> = ({
  title,
  onBack,
  onPrint,
  isMobile,
}) => {
  let { contractCode } = useOcCurrentUserState();
  const { data: currentStatementData } = useMyCafeteriaCurrentStatement({
    contractCode,
  });

  const disabled = currentStatementData?.state === "editable" ? true : false;

  const theme = useTheme();
  const { t } = useTranslation();

  const handlePrint = () => {
    if (disabled) {
      return;
    }
    onPrint();
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      padding={isMobile ? "16px" : "0px"}
      style={{
        backgroundColor: theme.palette.primary.main,
        height: isMobile ? "100%" : "64px",
        color: "white",
        borderRadius: "8px",
      }}
    >
      <Box
        color={theme.palette.white.main}
        height="24px"
        lineHeight="24px"
        onClick={onBack}
        id="btGoBack"
        paddingLeft={isMobile ? "0px" : "22px"}
      >
        <InlineIcon
          icon={arrowLeftIcon}
          style={{
            width: "24px",
            height: "24px",
            cursor: "pointer",
            color: theme.palette.white.main,
          }}
        />
      </Box>
      <Box
        display="flex"
        width="100%"
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "center" : "unset"}
      >
        <Box flexGrow={1} textAlign="center">
          <Typography variant="h4" style={{ color: theme.palette.white.main }}>
            {title}
          </Typography>
        </Box>
        {isMobile && <Box height="16px" />}
        <Box paddingRight="22px">
          {disabled ? (
            <OcCustomTooltip
              title={t("MY_CAFETERIA_DISABLED_APPLICATION_PRINT_BUTTON")}
              placement="bottom"
            >
              <Button
                id="print-button"
                onClick={handlePrint}
                style={{
                  height: "36px",
                  backgroundColor: "#E3E5E5",
                  fontSize: "14px",
                  letterSpacing: "0.75px",
                  borderRadius: "4px",
                  color: "#999999",
                  textTransform: "uppercase",
                  paddingLeft: "22px",
                  paddingRight: "22px",
                }}
              >
                {t("OC_PRINT")}
              </Button>
            </OcCustomTooltip>
          ) : (
            <Button
              id="print-button"
              onClick={handlePrint}
              style={{
                height: "36px",
                backgroundColor: "#E3E5E5",
                fontSize: "14px",
                letterSpacing: "0.75px",
                borderRadius: "4px",
                color: "#212121",
                textTransform: "uppercase",
                paddingLeft: "22px",
                paddingRight: "22px",
              }}
            >
              {t("OC_PRINT")}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default OcPrintHeader;
